// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const getBlogCategoryArticlesParameter = (state: ApplicationState) => {
    return state.starter.pages.blogCategory.getBlogCategoryArticlesApiParameter;
};
